import { z } from 'zod';
import { ManagedServiceType, ServiceProvider, ServiceStatus, BillingCycle, ServiceEventKind } from '../enums.js';
export const createManagedServiceInput = z.object({
    // Opzionale: un abbonamento puo' esistere senza cliente collegato (import da
    // Stripe che non ha trovato una corrispondenza certa in anagrafica).
    clientId: z.string().min(1).optional().nullable(),
    type: z.nativeEnum(ManagedServiceType),
    provider: z.nativeEnum(ServiceProvider).default('MANUAL'),
    planCode: z.string().min(1).max(80),
    planLabel: z.string().min(1).max(160),
    status: z.nativeEnum(ServiceStatus).default('TRIALING'),
    billingCycle: z.nativeEnum(BillingCycle).default('MONTHLY'),
    amount: z.number().nonnegative(), // canone INCASSATO per ciclo, in EUR
    listAmount: z.number().nonnegative().optional(), // canone a listino, se diverso da quello incassato
    costAmount: z.number().nonnegative().default(0), // costo da provider (es. HighLevel) per il ciclo
    currency: z.string().length(3).default('EUR'),
    externalId: z.string().max(200).optional().nullable(),
    externalUrl: z.string().max(500).optional().nullable(),
    startedAt: z.string().datetime().optional().nullable(),
    currentPeriodEnd: z.string().datetime().optional().nullable(),
    trialEndsAt: z.string().datetime().optional().nullable(),
    notes: z.string().max(5000).optional().nullable(),
    metadata: z.record(z.unknown()).optional(),
});
export const updateManagedServiceInput = createManagedServiceInput.partial().omit({ clientId: true });
export const managedServiceFilters = z.object({
    type: z.nativeEnum(ManagedServiceType).optional(),
    status: z.nativeEnum(ServiceStatus).optional(),
    provider: z.nativeEnum(ServiceProvider).optional(),
    clientId: z.string().optional(),
    search: z.string().optional(),
});
export const createServiceEventInput = z.object({
    kind: z.nativeEnum(ServiceEventKind),
    message: z.string().min(1).max(2000),
    metadata: z.record(z.unknown()).optional(),
});
export const managedServiceDTO = z.object({
    id: z.string(),
    type: z.nativeEnum(ManagedServiceType),
    provider: z.nativeEnum(ServiceProvider),
    status: z.nativeEnum(ServiceStatus),
    billingCycle: z.nativeEnum(BillingCycle),
    planCode: z.string(),
    planLabel: z.string(),
    amount: z.number(),
    listAmount: z.number(),
    costAmount: z.number(),
    currency: z.string(),
    externalId: z.string().nullable(),
    externalUrl: z.string().nullable(),
    startedAt: z.string().nullable(),
    currentPeriodEnd: z.string().nullable(),
    trialEndsAt: z.string().nullable(),
    cancelledAt: z.string().nullable(),
    client: z.object({ id: z.string(), legalName: z.string(), shortName: z.string() }).nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
//# sourceMappingURL=service.js.map